import MoveTo from 'moveto';

const moveTo = new MoveTo();

const triggers = document.querySelectorAll("[href^='#']");

for (let i = 0; i < triggers.length; i++) {
  moveTo.registerTrigger(triggers[i]);
}